import { useNavigate } from "react-router-dom";

export const SubsectionTabs = ({ items, active }) => {
  const navigate = useNavigate();

  return (
    <div className="overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0">
      <nav
        data-testid="subsection-tabs"
        aria-label="Sous-navigation"
        className="w-max min-w-full flex items-center gap-1 border-b border-slate-200"
      >
        {items.map((item) => {
          const Icon = item.icon;
          const selected = item.key === active;
          return (
            <button
              key={item.key}
              type="button"
              data-testid={`subsection-${item.key}`}
              aria-current={selected ? "page" : undefined}
              onClick={() => navigate(item.path)}
              className={`relative flex items-center gap-2 px-3 sm:px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors ${
                selected
                  ? "text-emerald-700"
                  : "text-slate-500 hover:text-slate-900"
              }`}
            >
              {Icon && <Icon className="w-4 h-4" />}
              {item.label}
              {selected && <span className="absolute inset-x-2 bottom-0 h-0.5 rounded-full bg-emerald-500" />}
            </button>
          );
        })}
      </nav>
    </div>
  );
};
